/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Danger_DescriptionInputs */

const zh_danger_description = /** @type {(inputs: Danger_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以下操作不可逆转，请谨慎操作。`)
};

const en_danger_description = /** @type {(inputs: Danger_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The following actions are irreversible. Please proceed with caution.`)
};

const es_danger_description = /** @type {(inputs: Danger_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las siguientes acciones son irreversibles. Procede con precaución.`)
};

/**
* | output |
* | --- |
* | "The following actions are irreversible. Please proceed with caution." |
*
* @param {Danger_DescriptionInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const danger_description = /** @type {((inputs?: Danger_DescriptionInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Danger_DescriptionInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_danger_description(inputs)
	if (locale === "en") return en_danger_description(inputs)
	return es_danger_description(inputs)
});